import React from 'react';
import { useSearchParams } from 'react-router-dom';
import WorkItemsView from '../components/WorkItemsView';
import PageContainer from '../components/PageContainer';

const WorkbenchPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const viewParam = searchParams.get('view');

  // Validate that the view param is a valid ViewKey, otherwise default to 'all'
  const initialView = (['inbox', 'applications', 'tasks', 'all'].includes(viewParam || '')
    ? viewParam
    : 'all') as any;

  return (
    <PageContainer>
      <WorkItemsView initialView={initialView} showHeader />
    </PageContainer>
  );
};

export default WorkbenchPage;
